module.exports = __webpack_public_path__ + "static/media/logo_signatures.bf28eb0f.png";